__turbopack_context__.v({
  "container": "LocalMarketBnbController-module-scss-module__8JvIUq__container",
});
